/******************************************************************************************
*	Modal Service
*******************************************************************************************
*
* Inspired by Brian Ford's modal implementation (https://github.com/btford/angular-modal).
*
* Params:
*  config.template: HTML string to be appended to .modal element
*  config.templateUrl: URL to the HTML template who's contents will be appended to .modal element
*  config.controller: string or function which acts as the controller for the modal
*  config.controllerAs: string, makes controller available on the scope of the modal as the given name
*  config.container: DOM node where to append the modal element. Defaults to document.body.
*  config.type: string, can be either one of "error", "notice", "success", "help", "info". Modal type controls header background colour and icon.
*  config.classNames: string enumeration of space delimited class names to be added to the .modal-backdrop element
*
* A modal looks like this:
    <div class="modal-backdrop">
      <div class="modal">
        <div class="modal-header">
          <h2>Title</h2>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body"></div>
        <div class="modal-footer"></div>
      </div>
    </div>
*
* Only the part inside .modal needs to be passed in as a template or templateURL.
*
*/
(function() {
  

  angular.module('rcServices.modal', []).factory(
    'modal',
    /* @ngInject */
    function($q, $http, $templateCache, $compile, $rootScope, $controller) {
      return function modalFactory(config) {
        if (+!!config.template + +!!config.templateUrl !== 1) {
          throw new Error(
            'Expected modal to have exactly one of either `template` or `templateUrl`.'
          );
        }

        //DOM
        var jqModalParent = angular.element(config.container || document.body);
        var jqBackdrop = angular.element(
          '<div class="modal-backdrop" ng-class="{\'show-loading-overlay\':loadingState}"></div>'
        );
        var jqModal = angular.element('<div class="modal"></div>');
        var jqLoadingOverlay = angular.element(
          '<div class="loading-overlay"><div class="spinner large center"></div></div>'
        );
        var jqModalContents = null;

        //Configs
        var template = config.template;
        var controller = config.controller || angular.noop;
        var controllerAs = config.controllerAs;

        //If classNames are specified, set them on the backdrop element
        if (config.classNames) {
          jqBackdrop.addClass(config.classNames);
        }

        //If type is specified, set it on the modal element
        var setType = function(type) {
          jqModal.addClass(type);
        };
        if (config.type) {
          setType(config.type);
        }

        //isInDom is true when modal is in DOM and false otherwise
        var isInDom = false;

        //Use the template HTML string
        var html;
        if (template) {
          var deferredHTML = $q.defer();
          deferredHTML.resolve(template);
          html = deferredHTML.promise;
        } else {
          //Or fetch the HTML from a template file
          html = $http.get(config.templateUrl, {cache: $templateCache}).then(function(response) {
            return response.data;
          });
        }

        //Attaches modal to DOM, instantiates new scope, creates controller and $compiles
        var scope;
        var attach = function(html, locals) {
          //DOM operations
          jqModalContents = angular.element(html);
          jqModal.append(jqModalContents); //Append template contents to modal
          jqModal.append(jqLoadingOverlay); //Append loading overlay element
          jqBackdrop.append(jqModal); //Append modal to backdrop

          //Scope
          scope = $rootScope.$new();
          if (locals) {
            for (var prop in locals) {
              scope[prop] = locals[prop];
            }
          }

          //Controller
          var ctrl = $controller(controller, {$scope: scope});
          if (controllerAs) {
            scope[controllerAs] = ctrl;
          }

          //Append backdrop to parent container
          jqModalParent.append(jqBackdrop);
          isInDom = true;

          //Compile against modal scope
          $compile(jqBackdrop)(scope);

          //Animate in
          setTimeout(function() {
            jqBackdrop.addClass('visible');
          }, 10); //Wait 10ms for reflow
        };

        //Appends modal to modal container element (usually document.body)
        var deferredModal = $q.defer();
        var create = function(locals) {
          html.then(function(html) {
            if (!isInDom) {
              attach(html, locals);
            }
          });
          return deferredModal.promise;
        };

        //Removes the modal from DOM and resets state
        var removalCleanup = function() {
          scope.$destroy();
          jqBackdrop.remove(); //Removes the element from DOM, but not from memory
          jqBackdrop.removeClass('show-loading-overlay'); //So removing this class if it existed is needed for example.
          jqModal.empty();
          jqModalContents = null;
          isInDom = false;
          loadingState = false;
          deferredModal = $q.defer(); //Let the create() method instantiate a new deferred object
        };

        //Removes modal from container
        var remove = function(data, rejected) {
          if (isInDom) {
            //Animate out
            jqBackdrop.removeClass('visible');
            deferredModal[rejected === true ? 'reject' : 'resolve'](data || null);
            removalCleanup();
          }
        };

        //Loading state
        var loadingState = false;
        var inLoadingState = function() {
          return loadingState;
        };
        var setLoadingState = function() {
          if (!inLoadingState()) {
            loadingState = true;
            scope.loadingState = loadingState;
          }
        };
        var unsetLoadingState = function() {
          if (inLoadingState()) {
            loadingState = false;
            scope.loadingState = loadingState;
          }
        };

        return {
          create: create,
          remove: remove,
          inLoadingState: inLoadingState,
          setLoadingState: setLoadingState,
          unsetLoadingState: unsetLoadingState,
          setType: setType
        };
      };
    }
  );
})();
